import { render } from "./RedesignTrainingComponent.vue?vue&type=template&id=38c785cf&scoped=true"
import script from "./RedesignTrainingComponent.vue?vue&type=script&lang=js"
export * from "./RedesignTrainingComponent.vue?vue&type=script&lang=js"

import "./RedesignTrainingComponent.vue?vue&type=style&index=0&id=38c785cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c785cf"]])

export default __exports__